module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3894461559/src/~/core-js/library/modules/_is-object.js
// module id = YmCC
// module chunks = 6